/**
 * Environment validation utilities
 */

export interface EnvironmentConfig {
  REACT_APP_SUPABASE_URL: string;
  REACT_APP_SUPABASE_ANON_KEY: string;
}

export const validateEnvironment = (): EnvironmentConfig => {
  const config: EnvironmentConfig = {
    REACT_APP_SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL || '',
    REACT_APP_SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
  };

  const missingVars = Object.entries(config)
    .filter(([_, value]) => !value)
    .map(([key]) => key);

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missingVars.join(', ')}. ` +
      'Please check your .env file and ensure all required variables are set. ' +
      'See env.example for reference.'
    );
  }

  return config;
};

export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};
